import { roleAtLeast, type Role } from './enums';

/** Caps aplicados quando o usuário que inicia o run tem `isTester`. */
export const TESTER_MAX_PRODUCTS = 5;
export const TESTER_MAX_SUGGESTIONS_PER_PRODUCT = 1;

/** Owner (global) ou tester (só os próprios, via assertAccess). */
export function canManageTenants(user: { role: Role; isTester: boolean }): boolean {
  return user.role === 'owner' || user.isTester;
}

/** Admin+ ou tester com acesso ao tenant. */
export function canTestTenantConnection(user: { role: Role; isTester: boolean }): boolean {
  return roleAtLeast(user.role, 'admin') || user.isTester;
}
